<template>
  <div class="frame" :class="$mq">
    <div v-if="!confirmed">
      <h1>{{ $t('Comeback.Supplier.title') }}</h1>
      <BecomeField
          name="supplier"
          type="select"
          :label="label('Supplier.choose')"
          v-model="provider"
          :possibleValues="possibleProviders"
          required/>

      <button :disabled="disabled" class="confirm button main " @click="confirm()">
        {{ $t("Comeback.Validation.confirm") }}
      </button>

      <div id="loss-disclaimers" v-if="offer.type === 'DISCOUNT_OFFER'">
        <p style="font-size:12px;" v-html="$t('Comeback.HotLoss.Discount.confirm_deal')"></p>
        <div style="text-align:left;" v-html="$t('Comeback.HotLoss.Discount.conditions_deal')"></div>
      </div>
      <div class="loss-disclaimer" v-if="offer.type === 'SPECIFIC_OFFER'">
        <p style="font-size: 12px;">{{ $t("Comeback.HotLoss.Specific.confirm") }}</p>
        <div style="text-align: left;"
             v-html="$tc('Comeback.HotLoss.Specific.conditions',Object.keys(this.rateCards).length, {
               maxAmount: offer.max_amount,
               rateCard : rateCardElec || rateCardGas,
               energy: hasElec ? $t('Comeback.HotLoss.Specific.elec') : $t('Comeback.HotLoss.Specific.gas'),
               rateCardElec : rateCardElec,
               rateCardGas: rateCardGas
             } )"></div>
      </div>
    </div>

    <div v-if="confirmed">
      <h2>{{ $t('Comeback.HotLoss.Confirmed.subTitle') }}</h2>
      <p>{{ $t('Comeback.HotLoss.Confirmed.text') }}</p>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import {mapState, mapGetters} from "vuex";
import geoService from "@/services/geoService";
import marketingService from "@/services/marketingService";
import DeliveryPoints from "../ColdLoss/DeliveryPoints";
import BecomeField from "../../../components/Form/BecomeField";

export default {
  name: "Supplier",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {DeliveryPoints, BecomeField},
  data() {
    return {
      provider: ''
    }
  },
  computed: {
    ...mapState('comeback', ['providers', 'offer', 'rateCards', 'confirmed']),
    ...mapGetters('comeback', ["outdated", 'hasElec', 'hasGas']),
    possibleProviders() {
      return this.providers.map(provider => {
        return {label: provider.name, value: provider.id}
      })
    },
    rateCardElec() {
      if (this.hasElec && this.rateCards.electricity) {
        return this.rateCards.electricity.url;
      }
      return '';
    },
    rateCardGas() {
      if (this.hasGas && this.rateCards.gas) {
        return this.rateCards.gas.url;
      }
      return '';
    },
  },
  methods: {
    async confirm() {
      await this.$store.dispatch('comeback/confirmHotLoss', this.provider)
    },
    label(text) {
      return this.$t('Comeback.' + text);
    }
  },
  created() {
    if (this.offer.supplier) {
      this.provider = this.offer.supplier
    }
  }
}
</script>

<style scoped>
p {
  text-align: left;
}

select {
  border-radius: 4px!important;
  padding: 2px 0 2px 0;
  min-width: 250px;
}

select:disabled {
  background: #f5f5f5;
}

.button.main.confirm {
  background: #FDCA47;
  margin: 15px 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Comeback/HotLoss/Supplier.vue